const carRental = {
  carRental: "汽车出租", // translated
  carRentals: "租车", // translated
  pickUpPoint: "接送点", // translated
  dropOffPoint: "下车点", // translated
  pickUpDate: "挑个日子", // translated
  dropOffDate: "还车日期", // translated
  pickUp: "捡起", // translated
  dropOff: "放下", // translated
  edit: "编辑", // translated
  fuelPolicy: "燃油政策", // translated
  pickUpLocation: "接人的地方", // translated
  mileage: "里程", // translated
  transmission: "传播", // translated
  airCondition: "空调", // translated
  minimumAge: "最低年龄", // translated
  maximumAge: "最大年龄", // translated
  providerAddress: "提供者地址", // translated
  providerPhone: "提供商电话", // translated
  driverInfo: "司机信息", // translated
  driversInfo: "司机信息", // translated
  differentDropOff: "不同地点下车", // translated
  maxPassengers: "最大载客量", // translated
  budget: "预算", // translated
  provider: "提供者", // translated
  carModel: "汽车模型", // translated
  numOfDoors: "门数", // translated
  fuelType: "汽油种类", // translated
  driverAge: "驾驶员年龄", // translated
  workingHours: "工作时间", // translated
  driverNationality: "驾驶员国籍", // translated
  carRentalRate: "租车价格", // translated
  dueNow: "现在到期", // translated
  duePickUp: "取车时到期", // translated
  toViewOfferPDF: "要查看包含此优惠的所有租赁条款的 PDF 文档，请", // translated
  toViewTermsAndCondPDF: "要查看适用的 CARNECT 条款和条件，请", // translated
};


export default carRental;
